




import { Component, mixins } from 'nuxt-property-decorator';
import ReferralPrizeMixin from '~/components/partials/referral/ReferralInvite/referralPrizeMixin';

import type { PortfolioCurrentUser, UserReferrerQuery } from '~/types/graphql';

import ReferralOnboarding from '~/components/partials/referral/Onboarding/Onboarding.vue';
import userReferrerQuery from '~/apollo/queries/userReferrer.query';
import { INDEX_PAGE } from '~/constants';

@Component<ReferralPreOnboardingPage>({
  layout: 'clear',
  components: {
    ReferralOnboarding,
  },
  key() {
    return 'referral-pre-onboarding';
  },
  apollo: {
    userReferrer: {
      query: userReferrerQuery,
      variables() {
        return {
          invite: this.$route.query.mrk || '',
        };
      },
      result({ data }: { data: UserReferrerQuery }): void {
        if (!data.userReferrer) {
          this.$notice.error('Invalid or expired referral link');
          this.$router.push(INDEX_PAGE);
        }

        this.userReferrer = data.userReferrer as Partial<PortfolioCurrentUser>;
      },
      fetchPolicy: 'no-cache',
    },
  },
})
export default class ReferralPreOnboardingPage extends mixins(ReferralPrizeMixin) {
  userReferrer: Partial<PortfolioCurrentUser> | null = null;

  head() {
    return this.$seo({
      title: `You were referred and can earn ${this.moneyPrize} if get hired at Bravado jobs!`,
      description: `In this economy, you should ABI (Always Be Interviewing). Now get paid ${this.moneyPrize} if you land a new gig through us.`,
    });
  }
}
